import { useEffect } from 'react';
import { gamesStoreActions } from '../../../store';

const { PLEX_SET_PAGINATION } = gamesStoreActions;

export const usePlexPaginationSetInitialData = ({
  isNotAllowedToSetInitialData,
  pageSize,
  gamesFromLobby,
  paginationGames = [],
  formattedPage,
  entity,
  entityId,
  setIsInitialDataLoaded,
  loadGames,
  isSetFirstPageWithGamesFromLobby
}) => {
  const isFirstPage = formattedPage === 1;

  // set initial value
  useEffect(() => {
    (async () => {
      if (isNotAllowedToSetInitialData) {
        return;
      }

      if (
        (isFirstPage && isSetFirstPageWithGamesFromLobby) ||
        (formattedPage && paginationGames.length)
      ) {
        const loadedGames =
          isFirstPage && isSetFirstPageWithGamesFromLobby
            ? gamesFromLobby?.slice(0, pageSize)
            : [...paginationGames];

        PLEX_SET_PAGINATION({
          entity,
          pagination: {
            id: entityId,
            gamesIds: loadedGames
          }
        });
        setIsInitialDataLoaded(true);
      } else {
        await loadGames({
          offset: 0,
          limit: pageSize * formattedPage,
          isInitialCall: true
        });

        setIsInitialDataLoaded(true);
      }
    })();
  }, [
    gamesFromLobby,
    isFirstPage,
    formattedPage,
    pageSize,
    entityId,
    isNotAllowedToSetInitialData
  ]);
};
